import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'travel-ui-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss']
})
export class ChipsComponent implements OnInit {
  @Input() chipText: any;
  @Output() remove = new EventEmitter();
  constructor() { }

  removeChip() {
    this.remove.emit(this.chipText);
  }

  ngOnInit() { }
}
